// extracted by mini-css-extract-plugin
export default {"wrapper":"NewsList_wrapper__H1Tbi","container":"NewsList_container__0zQbi","title":"NewsList_title__wdPzB"};